export default {
  height: 24
};
